import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import { Container } from '@mui/material';
import PageHeaders from '../../../Utils/PageHeaders';

// Import components
import FAQSection from './components/FAQSection';
import PricingHero from './components/PricingHero';
import PlanSelection from './components/PlanSelection';
// Developed and managed by Mejona technology

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    minHeight: '100vh',
    backgroundColor: '#ffffff',
  },
  container: {
    paddingTop: theme.spacing(8),
    paddingBottom: theme.spacing(8),
    [theme.breakpoints.down('md')]: {
      paddingTop: theme.spacing(6),
      paddingBottom: theme.spacing(6),
    },
  },
}));

const Pricing = () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <PageHeaders
        title="Pricing - Plootus Retirement Planning Plans"
        description="Choose the right Plootus plan for your retirement planning needs. Transparent pricing with no hidden fees. Start planning your financial future today."
        keywords="Plootus pricing, retirement planning costs, financial planning plans, investment advice pricing"
        canonicalUrl="https://www.plootus.com/pricing"
      />
      <PricingHero />
      <PlanSelection />
      {/* <FAQSection /> */}
    </div>
  );
};

export default Pricing;
